import jsonwebtoken from "jsonwebtoken";
import { autoSignIn } from "@/services/sso";
import { getAccessToken } from "@/services/auth";

const TokenHelper = {
  getPayloadField: async function (key, token = null) {
    if (!token) token = await getAccessToken();
    const decoded = jsonwebtoken.decode(token);
    if (!decoded) return null;
    return decoded[key];
  },

  getExpiry: async function (token = null) {
    if (!token) token = await getAccessToken();
    const decoded = jsonwebtoken.decode(token);
    if (!decoded) return null;
    return decoded.exp * 1000;
  },

  checkExpiry: async function (token = null) {
    const tokenExpired = await this.hasExpired(token);

    if (!tokenExpired) {
      return tokenExpired;
    }

    // Don't auto sign in if we're on the login page or if manual login is in progress
    if (window.location.pathname === "/login") {
      return tokenExpired;
    }

    if (process.env.VUE_APP_CSA_SELF_SIGN_IN) {
      const autoSignInSuccess = await autoSignIn(); // Skip navigation to avoid conflicts
      // Return false (not expired) if auto sign-in succeeded, true (expired) if it failed
      return !autoSignInSuccess;
    }

    window.location = "https://www.chesssquad.com";
    return tokenExpired;
  },

  hasExpired: async function (token = null) {
    if (!token) token = await getAccessToken();
    if (!token) return true;

    const expiry = await this.getExpiry(token);
    if (!expiry || expiry < Date.now()) return true;

    return false;
  },
};

export default TokenHelper;
